import React from "react";
import moment from "moment";

export const cellRendererCheck = (value) => {
  if(typeof value === "number") return value;
  if (!value || /^\s*$/.test(value) ) return "-";
  return value;
};
export const cellRenderRefillNo = (value) => {
  if (!value) return '0';
  return value;
};
export const roundOfTwoDecimal = (value) => {
  if(typeof value === "number") return value.toFixed(2);
  if (!value || /^\s*$/.test(value) ) return "-";
  return value;
};

export const currencyFormat = (value) => {
  if (!value || isNaN(value)) return "$0.00";
  if (value < 0)
    return (
      <span className="text-danger text-end">
        {"-$" +
          (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
      </span>
    );
  else
    return (
      <span className="text-end">
        {"$" + (value * 1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
      </span>
    );
};


export const fileFormatter = (row, download) => {
  const { files } = row;
  if (files && files.length) {
    return files.map((file, index) => {
      return (
        <span
          className="fax-link"
          key={`${file.fileName}${index}`}
          onClick={() => download(file)}
        >
          {file.fileName}
          <br />
        </span>
      );
    });
  }
  return <span>There is no attachment</span>;
};

export const dateFormate = (value) => {
  if (!value || !moment(value).isValid()) return "-";
  return moment(new Date(value)).format("MM/DD/YYYY");
};

export const dateFormate1 = (value) => {
  if (!value || !moment(value, "YYYYMMDD", true).isValid()) return "-";
  return moment(value, "YYYYMMDD").format("MM/DD/YYYY");
};

const commonColumns = [
  {
    dataField: "patientFirstName",
    text: "Patient First Name",
    cellRenderer: (rowData) => cellRendererCheck(rowData.patientFirstName),
    sort: true,
    width: 144,
    show: true,
    inputType: "text",
  },
  {
    dataField: "patientLastName",
    text: "Patient Last Name",
    sort: true,
    width: 140,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.patientLastName),
  },
  {
    dataField: "patientDOB",
    text: "Patient DOB",
    sort: true,
    width: 140,
    show: true,
    inputType: "date",
    cellRenderer: (rowData) => dateFormate(rowData.patientDOB),
  },
  {
    dataField: "medicalRecordNumber",
    text: "Medical Record Number",
    sort: true,
    width: 140,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.medicalRecordNumber),
  },
  {
    dataField: "claimStatus",
    text: "Claim Status",
    sort: false,
    cellRenderer: (rowData) => cellRendererCheck(rowData.claimStatus),
    width: 130,
    show: true,
    edit: true,
    inputType: "text",
    hideColFilter: true,
  },
  {
    dataField: "reasonDesc",
    text: "Reason",
    sort: false,
    cellRenderer: (rowData) => cellRendererCheck(rowData.reasonDesc),
    width: 150,
    show: true,
    edit: true,
    inputType: "text",
    hideColFilter: true,
  },
  {
    dataField: "rxNumber",
    text: "RX Number",
    sort: true,
    width: 90,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.rxNumber),
  },
  {
    dataField: "refillNumber",
    text: "Refill Number",
    sort: true,
    width: 90,
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => cellRendererCheck(rowData.refillNumber),
  },
  {
    dataField: "dateRXWritten",
    text: "Date Rx Written",
    cellRenderer: (rowData) => dateFormate(rowData.dateRXWritten),
    sort: true,
    width: 120,
    show: true,
    inputType: "date",
  },
  {
    dataField: "dateofService",
    text: "Date of Service",
    cellRenderer: (rowData) => dateFormate(rowData.dateofService),
    sort: true,
    width: 120,
    show: true,
    inputType: "date",
  },
  {
    dataField: "ndc",
    text: "NDC",
    sort: true,
    width: 110,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.ndc),
  },
  {
    dataField: "drugName",
    text: "Drug Name",
    sort: true,
    width: 100,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.drugName),
  },
  {
    dataField: "qtyDispensed",
    text: "Qty Dispensed",
    sort: true,
    width: 100,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.qtyDispensed),
  },
  {
    dataField: "daysSupply",
    text: "Days Supply",
    sort: true,
    width: 100,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.daysSupply),
  },
  {
    dataField: "gcnSequenceNumber",
    text: "GCN Sequence Number",
    sort: true,
    width: 150,
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => cellRendererCheck(rowData.gcnSequenceNumber),
  },
  {
    dataField: "manufacturerName",
    text: "Manufacturer Name",
    sort: true,
    width: 120,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.manufacturerName),
  },
  {
    dataField: "drugStatusDesc",
    text: "Drug Status Desc",
    sort: true,
    width: 120,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.drugStatusDesc),
  },
  {
    dataField: "claimType",
    text: "Claim Type",
    sort: true,
    width: 120,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.claimType),
  },
  {
    dataField: "claimSubType",
    text: "Claim Sub Type",
    sort: true,
    width: 120,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.claimSubType),
  },
  {
    dataField: "sourceReason",
    text: "Source Reason",
    sort: true,
    width: 120,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.sourceReason),
  },
  {
    dataField: "totalPaid",
    text: "Total Paid",
    sort: true,
    width: 125,
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => currencyFormat(rowData.totalPaid),
    className: "text-end",
  },
  {
    dataField: "dispensingFee",
    text: "Dispensing Fee",
    sort: true,
    width: 125,
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => currencyFormat(rowData.dispensingFee),
    className: "text-end",
  },
  {
    dataField: "ceReceivable",
    text: "CE Receivable",
    sort: true,
    width: 125,
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => currencyFormat(rowData.ceReceivable),
    className: "text-end",
  },
  {
    dataField: "drugCost340B",
    text: "Drug Cost 340B",
    sort: true,
    width: 125,
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => currencyFormat(rowData.drugCost340B),
    className: "text-end",
  },
  {
    dataField: "profitLoss",
    text: "Profit/Loss",
    sort: true,
    width: 125,
    textAlign: "right",
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => currencyFormat(rowData.profitLoss),
    className: "text-end",
  },
  {
    dataField: "hasVisit",
    text: "Eligible Visit",
    sort: false,
    width: 130,
    show: true,
    inputType: "text",

    cellRenderer: (rowData) => cellRendererCheck(rowData.hasVisit),
    hideColFilter: true,
  },
  {
    dataField: "providerNPI",
    text: "Provider NPI",
    sort: true,
    width: 120,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.providerNPI),
  },
  {
    dataField: "providerFirstName",
    text: "Provider First Name",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.providerFirstName),
  },
  {
    dataField: "providerLastName",
    text: "Provider Last Name",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.providerLastName),
  },
  {
    dataField: "providerSpecialty",
    text: "Provider Specialty",
    sort: false,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.providerSpecialty),
    hideColFilter: true,
  },
  {
    dataField: "providerStatus",
    text: "Provider Status",
    sort: false,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.providerStatus),
    hideColFilter: true,
  },
  {
    dataField: "faxNumber",
    text: "Fax Number",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.faxNumber),
  },
  {
    dataField: "faxCount",
    text: "Fax Count",
    sort: true,
    width: 130,
    show: true,
    inputType: "number",
    cellRenderer: (rowData) => cellRendererCheck(rowData.faxCount),
  },
  {
    dataField: "pharmacyNPI",
    text: "Pharmacy NPI",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyNPI),
  },
  {
    dataField: "pharmacyName",
    text: "Pharmacy Name",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyName),
  },
  {
    dataField: "bin",
    text: "BIN",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.bin),
  },
  {
    dataField: "pcn",
    text: "PCN",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.pcn),
  },
  {
    dataField: "groupNumber",
    text: "Group Number",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.groupNumber),
  },
  {
    dataField: "secondaryBIN",
    text: "Secondary BIN",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryBIN),
  },
  {
    dataField: "secondaryPCN",
    text: "Secondary PCN",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryPCN),
  },
  {
    dataField: "secondaryGroup",
    text: "Secondary Group",
    sort: true,
    width: 130,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryGroup),
  },

  {
    dataField: "createdDate",
    text: "Created Date",
    sort: true,
    width: 125,
    show: true,
    inputType: "date",
    cellRenderer: (rowData) => dateFormate(rowData.createdDate),
  },
  {
    dataField: "createdBy",
    text: "Created By",
    sort: false,
    width: 125,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.createdBy),
    hideColFilter: true,
  },
  {
    dataField: "claimStatusChangeDate",
    text: "Status Change Date",
    sort: true,
    width: 125,
    show: true,
    inputType: "date",
    cellRenderer: (rowData) => dateFormate(rowData.claimStatusChangeDate),
  },
  {
    dataField: "statusChangedBy",
    text: "Status Changed By",
    sort: false,
    width: 125,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.statusChangedBy),
    hideColFilter: true,
  },
  {
    dataField: "completedDate",
    text: "Completed Date",
    sort: true,
    width: 125,
    show: true,
    inputType: "date",
    cellRenderer: (rowData) => dateFormate(rowData.completedDate),
  },
  {
    dataField: "completedBy",
    text: "Completed By",
    sort: false,
    width: 125,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.completedBy),
    hideColFilter: true,
  },
  {
    dataField: "invoicedDate",
    text: "Invoiced Date",
    sort: true,
    width: 125,
    show: true,
    inputType: "date",
    cellRenderer: (rowData) => dateFormate(rowData.invoicedDate),
  },
  {
    dataField: "invoicedBy",
    text: "Invoiced By",
    sort: false,
    width: 125,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.invoicedBy),
    hideColFilter: true,
  },
  {
    dataField: "modifiedDate",
    text: "Modified Date",
    sort: true,
    width: 125,
    show: true,
    inputType: "date",
    cellRenderer: (rowData) => dateFormate(rowData.modifiedDate),
  },
  {
    dataField: "modifiedBy",
    text: "Modified By",
    sort: false,
    width: 125,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.modifiedBy),
    hideColFilter: true,
  },
  {
    dataField: "claimID",
    text: "Claim ID",
    sort: false,
    width: 125,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.claimID),
    hideColFilter: true,
  },
  {
    dataField: "sourceClaimID",
    text: "Source Claim ID",
    sort: false,
    width: 125,
    show: true,
    inputType: "text",
    cellRenderer: (rowData) => cellRendererCheck(rowData.sourceClaimID),
    hideColFilter: true,
  },
];

// export const dateOnly = (value) => {
//   if (!value) return '-';
//   let val = value;

//   let regex = /^[a-zA-Z]/i;

//   if (regex.test(val)) {
//     return moment(new Date(val)).format('MM/DD/YYYY');
//   }

//   let hasTimePartZero = false;
//   console.log(val);
//   if (val.indexOf("T") == -1) {
//     val = val + "T00:00:00";
//     hasTimePartZero = true;
//   }
//   else if (val.indexOf("T00:00:00") != -1) {
//     hasTimePartZero = true;
//   }
//   else if (val.indexOf("T") != -1) {
//     let dtArr = val.split("T");
//     val = dtArr[0] + "T00:00:00";
//     hasTimePartZero = true;
//   }
//   if (hasTimePartZero) {
//     return moment(new Date(val)).format('MM/DD/YYYY')
//   }
//   //return moment(new Date(value)).local().format('MM/DD/YYYY');
//   return moment.utc(value).local().format('MM/DD/YYYY');
// }

export default commonColumns;
